import type { FaireProductEntity } from "../../entity_types/product";

export const p_kjbf9x9spe: FaireProductEntity = {
  token: "p_kjbf9x9spe",
  type: "product",
  name: "Dainty Sun Charm Layering Necklace in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/95eb77c87d69b42c33a69c6aa7c2d96f20b2f48b21a938bb560c2281854cf5b5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3e5e8e5befa61444eaa1b322061794a86f48342f2514a7c813a8ab0d44836f5.jpeg",
    "https://cdn.faire.com/fastly/d1493ab1e15e5db66627a902ece4acb63e80de8dd16fdc4255374dc0f7b738c2.png",
    "https://cdn.faire.com/fastly/0539806a030549ad8ab10d995788eb19db18a0c4319d05bf3e448cc37d7fb4e6.jpeg",
    "https://cdn.faire.com/fastly/0b3630fe13f6af1f4e456850eaa8b7ceaae1123ed8366282c6536ed21d3aa05f.png",
    "https://cdn.faire.com/fastly/d30e41de4b4616db04b361203b072298eaf54a7d4ab6279e2bceb2192e75be14.jpeg",
  ],
  priceDollars: 12.5,
  description:
    "Description & Details\n\nImmerse yourself in the celestial realm with our meticulously crafted pieces, designed to capture the celestial elements in stunning detail. Whether you're drawn to the radiant sun, the mysterious moon, or the twinkling stars, our sun, moon, and star Jewelry will add a celestial touch to your look.\n\n• Material: Solid 925 Sterling Silver\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 13 x 10 mm charm, 40 - 45 cm chain, adjustable\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:54.705Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
